<div class="spinner-overlay">
  <mat-progress-spinner
    class="spinner"
    color="primary"
    mode="indeterminate"></mat-progress-spinner>
</div>

